/**
 * Centralized text content for SODECO (EN / ES).
 */
export const content = {
    es: {
        nav: { home: "Inicio", missions: "Misiones", contact: "Contáctanos" },
        actions: {
            search: "Buscar",
            searchPlaceholder: "Buscar misiones, años o lugares…",
            send: "Enviar mensaje",
            sending: "Enviando…",
            readMore: "Leer más",
            ourMissions: "Nuestras misiones",
            getInvolved: "Únete a nosotros",
            close: "Cerrar",
            noResults: "Sin resultados",
            results: "resultados",
        },
        home: {
            eyebrow: "Sociedad De Desarollo comunitario · desde 1994",
            heroTitle: "Sostener la dignidad humana donde más se necesita.",
            heroSubtitle:
                "SODECO acompaña a comunidades vulnerables en cuatro continentes con programas de salud, educación y resiliencia Medica.",
            ctaPrimary: "Conocer las misiones",
            ctaSecondary: "Contáctanos",
            aboutEyebrow: "Sobre SODECO",
            aboutTitle: "Una misión guiada por la fe, la solidaridad y el servicio humano.",
            aboutLead:
                "SODECO fue fundada el 31 de enero de 1994 en el Distrito Municipal de La Victoria, República Dominicana, bajo el lema “Dios - Familia - Educación”. Nació como una institución misionera y cristiana comprometida con llevar esperanza, apoyo y transformación a las comunidades más vulnerables., SODECO (Sociedad De Desarrollo Comunitario) nació de un grupo de médicos, ingenieros y maestros convencidos de que la ayuda humanitaria solo es real cuando es continua, local y respetuosa.",
            aboutP1:
                "Desde sus inicios, SODECO ha trabajado avanzando bajo la voluntad de Dios, desarrollando misiones humanitarias en lugares donde muchas personas viven en condiciones de pobreza y necesidad extrema. Nuestra labor se centra en brindar ayuda solidaria, acompañamiento espiritual y oportunidades de desarrollo comunitario.",
            aboutP2:
                "Como institución misionera y cristiana, creemos en el poder de la fe, la educación y la unión familiar para transformar vidas. Cada proyecto y cada acción de SODECO busca impactar positivamente a las comunidades, promoviendo valores humanos, solidaridad y un futuro más digno para todos.",
            statsTitle: "SODECO en cifras",
            stats: [
                { value: "28", label: "años de trabajo continuo" },
                { value: "14", label: "Provincia atendidos" },
                { value: "+1.2M", label: "personas alcanzadas" },
                { value: "1$", label: "de cada dólar a la educación" },
            ],
            pillarsTitle: "Nuestros pilares",
            pillars: [
                { title: "Salud comunitaria", body: "Clínicas móviles, atención materno-infantil y campañas de operativos medico general." },
                { title: "Educación digna", body: "Reconstrucción de escuelas, programas para niñas y educación bilingüe intercultural." },
                { title: "Resiliencia comunitaria", body: "Reconstrucción de infraestructura, Reconstrucción de iglesias, rasiones alimenticias  ,." },
                { title: "Protección y derechos", body: "Apoyo legal y psicológico a personas desplazadas, refugiadas y menores no acompañados." },
            ],
            quote: "“La labor humanitaria no es caridad; es justicia, solidaridad y amor puestos en acción cada día.”",
            quoteAuthor: "— Dr. Juan Martinez , Vice Presidente de SODECO",

            // ---------- NUEVO: Testimonios ----------
            testimonialsEyebrow: "Voces que nos acompañan",
            testimonialsTitle: "Testimonios sobre el impacto de SODECO.",
            testimonials: [
                {
                    quote:
                        "“SODECO no llegó únicamente a ayudarnos: llegó a quedarse. En los momentos más difíciles, cuando parecía que todo se derrumbaba, ellos estuvieron presentes con apoyo y compromiso. Hoy, cinco años después, sigo agradeciendo su constancia, porque gracias a ellos mi familia encontró esperanza y fuerza para seguir adelante.”",
                    name: "Marina Pérez",
                    role: "Madre de familia · La Vega, RD",
                },
                {
                    quote:
                        "“Hubo momentos en los que no tenía nada para comer y me preocupaba cada día por cómo alimentar a mi familia y a mí mismo. Cuando ya no pude soportarlo más, le pedí ayuda a Dios, y SODECO vino. Ellos trajeron protección, cuidado y el alimento que nos sostuvo cuando más lo necesitábamos.”",
                    name: "Andrés Lugo",
                    role: "Voluntario · Antakya, Turquía",
                },
                {
                    quote:
                        "““Vi la grandeza de Dios a través de SODECO. En mis momentos más difíciles, cuando no tenía nada y me sentía sin esperanza, oré, y Dios respondió enviando a SODECO. Ellos me cuidaron, me protegieron y me dieron fuerzas. Hoy puedo decir que Dios es maravilloso, y que SODECO es Su instrumento de amor y esperanza en mi vida”",
                    name: "Dra. Helena Rivas",
                    role: "Directora · Universidad Iberoamericana",
                },
            ],

            // ---------- NUEVO: Frases bíblicas ----------
            bibleEyebrow: "Inspiración",
            bibleTitle: "Frases que nos guían cada día.",
            bibleVerses: [
                {
                    text:
                        "“En todo te he enseñado que, trabajando así, se debe ayudar a los necesitados, y recordar las palabras del Señor Jesús, que dijo: Más bienaventurado es dar que recibir.”",
                    ref: "Hechos 20:35",
                },
                {
                    text:
                        "“La religión pura y sin mancha delante de Dios el Padre es esta: visitar a los huérfanos y a las viudas en sus tribulaciones.”",
                    ref: "Santiago 1:27",
                },
                {
                    text:
                        "“Abre tu boca por el mudo en el juicio de todos los desvalidos. Abre tu boca, juzga con justicia, y defiende la causa del pobre y del menesteroso.”",
                    ref: "Proverbios 31:8-9",
                },
                {
                    text:
                        "“De cierto os digo que en cuanto lo hicisteis a uno de estos mis hermanos más pequeños, a mí lo hicisteis.”",
                    ref: "Mateo 25:40",
                },
            ],

            // ---------- NUEVO: Impacto en República Dominicana ----------
            drEyebrow: "Caribe · enfoque país",
            drTitle: "Nuestro impacto en República Dominicana.",
            drLead:
                "Desde 2012, República Dominicana se ha convertido en uno de los ejes operativos de SODECO en el Caribe. Hemos trabajado con comunidades en Barahona, Higüey, Santiago , Puerto Plata,  El seibo , La victoria, La Romana y Monte plata, articulando programas de salud, educación, vivienda digna y rasiones alimenticias.",
            drStats: [
                { value: "28", label: "años en el país" },
                { value: "27", label: "comunidades atendidas" },
                { value: "+85K", label: "dominicanos beneficiados" },
                { value: "37", label: "Iglesias reconstruidas" },
            ],
            drP1:
                "En 2017, tras el devastador paso del huracán María, desplegamos brigadas médicas y llevamos esperanza a las comunidades más golpeadas del este del país, entregando más de 12,000 kits de emergencia. Nuestro apoyo alcanzó familias enteras, hogares destruidos, iglesias, escuelas y personas con discapacidad que habían quedado en condiciones de extrema vulnerabilidad. Más que una respuesta humanitaria, fue un compromiso firme con la dignidad humana: estar presentes cuando todo parecía perdido y demostrar que la solidaridad puede convertirse en el primer paso hacia la reconstrucción y la esperanza.",
            drP2:
                "Trabajamos de la mano con iglesias locales, juntas de vecinos y programas de salud materno-infantil, fortaleciendo redes comunitarias que generan apoyo real y sostenible. Creemos que el cambio duradero nace desde las propias comunidades, por eso impulsamos iniciativas que no solo atienden necesidades inmediatas, sino que también promueven educación, bienestar, inclusión y oportunidades para las generaciones futuras.",

            // ---------- NUEVO: Equipo / Staff jerárquico ----------
            staffEyebrow: "Quiénes hacen posible SODECO",
            staffTitle: "Nuestro equipo.",
            staffSubtitle:
                "Una estructura clara y rendida de cuentas. Del liderazgo estratégico hasta los especialistas en el terreno.",
            staff: {
                ceo: { name: "Dr. Octavio Ariza Nuñez", role: "Presidente · CEO" },
                executiveDirector: { name: "Dr. Juan Martínez", role: "Director Ejecutivo En U.S.A · Vicepresidente" },
                managersLabel: "Managers",
                managers: [
                    { name: "Ing. Carlos Reyes", role: "Manager · Operaciones" },
                    { name: "Lic. Ana Beltrán", role: "Manager · Programas" },
                    { name: "Lic. Pedro Cabrera", role: "Manager · Desarrollo Comunitario" },
                ],
                supervisorsLabel: "Supervisores",
                supervisors: [
                    { name: "Sofía Núñez", role: "Supervisora · Salud" },
                    { name: "Camilo Tavárez", role: "Supervisor · Educación" },
                    { name: "Isabela Mora", role: "Supervisora · Comunicación" },
                    { name: "Luis Hernández", role: "Supervisor · Logística" },
                ],
                specialistsLabel: "Agentes especialistas",
                specialists: [
                    { name: "Daniela Frías", role: "Especialista · Pediatría" },
                    { name: "Jorge Acosta", role: "Especialista · Agua y saneamiento" },
                    { name: "Mónica Ríos", role: "Especialista · Psicología" },
                    { name: "Tomás Cuevas", role: "Especialista · Educación rural" },
                    { name: "Valentina Soto", role: "Especialista · Datos" },
                    { name: "Eduardo Castro", role: "Especialista · Voluntariado" },
                ],
            },
        },
        missions: {
            eyebrow: "Línea de tiempo",
            title: "34 años en el terreno.",
            subtitle:
                "Una cronología de misiones humanitarias de SODECO: lugares visitados, personas acompañadas y aprendizajes que nos transformaron.",
            visit: "Lugar visitado",
        },
        contact: {
            eyebrow: "Hablemos",
            title: "Contáctanos.",
            subtitle:
                "Cuéntanos cómo quieres colaborar — voluntariado, alianzas institucionales, prensa o donaciones. Te responderemos en 48 horas.",
            name: "Nombre completo",
            email: "Correo electrónico",
            subject: "Asunto",
            message: "Mensaje",
            sent: "Mensaje enviado. Gracias por contactarnos.",
            error: "No pudimos enviar tu mensaje. Inténtalo de nuevo.",
            officeTitle: "Oficinas",
            offices: [
                { city: "Ciudad de Santo Domingo Villa mella ", line: "Calle M " },
                { city: "Santo Domingo Norte Villa mella", line: "Calle M C 59" },
                { city: "Santo Domingo Norte ", line: "Calle M C 59" },
            ],
            hoursTitle: "Horario",
            hoursLine: "Lun – Vie · 09:00 – 18:00",
            emailTitle: "Correo",
            phoneTitle: "Teléfono",
        },
        footer: {
            tagline:
                "Solidaridad y Desarrollo Comunitario. Fundación humanitaria independiente registrada en 1994.",
            explore: "Explorar",
            connect: "Conectar",
            legal: "© " + new Date().getFullYear() + " SODECO. Todos los derechos reservados.",
        },
    },
    en: {
        nav: { home: "Home", missions: "Missions", contact: "Contact" },
        actions: {
            search: "Search",
            searchPlaceholder: "Search missions, years or places…",
            send: "Send message",
            sending: "Sending…",
            readMore: "Read more",
            ourMissions: "Our missions",
            getInvolved: "Get involved",
            close: "Close",
            noResults: "No results",
            results: "results",
        },
        home: {
            eyebrow: "Humanitarian foundation · since 1994",
            heroTitle: "Holding human dignity where it is needed the most.",
            heroSubtitle:
                "SODECO walks with vulnerable communities across four continents through health, education and climate-resilience programs.",
            ctaPrimary: "Explore our missions",
            ctaSecondary: "Get in touch",
            aboutEyebrow: "About SODECO",
            aboutTitle: "A mission guided by faith, solidarity, and human service.",
            aboutLead:
                "SODECO was founded on January 31, 1994, in the Municipal District of La Victoria, Dominican Republic, under the motto “God – Family – Education.” It was born as a missionary and Christian institution committed to bringing hope, support, and transformation to the most vulnerable communities. SODECO (Community Development Society) emerged from a group of doctors, engineers, and teachers convinced that humanitarian aid is only real when it is continuous, local, and respectful.",
            aboutP1:
                "From the very start, SODECO has moved forward under God’s will, bringing humanitarian missions to communities facing poverty and extreme hardship. Our mission is centered on offering compassionate aid, spiritual support, and pathways for community growth.",
            aboutP2:
                "Rooted in our missionary and Christian identity, we embrace the power of faith, education, and family unity to transform lives. Through each project and initiative, SODECO strives to uplift communities, fostering human values, solidarity, and a dignified future for all.",
            statsTitle: "SODECO in figures",
            stats: [
                { value: "28", label: "years on the ground" },
                { value: "14", label: "Provinces served" },
                { value: "+1.2M", label: "people reached" },
                { value: "1$", label: "From every dollar to education" },
            ],
            pillarsTitle: "Our pillars",
            pillars: [
                { title: "Community health", body: "Mobile clinics, maternal and child healthcare, and general medical outreach campaigns" },
                { title: "Dignified education", body: "Reconstruction of schools, initiatives for girls, and bilingual intercultural education." },
                { title: "Community resilience", body: "Reconstruction of infrastructure, reconstruction of churches, food rations." },
                { title: "Protection & rights", body: "Legal and psychological support for displaced people, refugees and unaccompanied minors." },  
            ],
            quote: "“Humanitarian work is not charity; it is justice, solidarity, and love put into action every day.”",
            quoteAuthor: "— Dr. Juan Martinez, Vice President of SODECO",

            testimonialsEyebrow: "Voices that walk with us",
            testimonialsTitle: "Testimonials on SODECO's impact.",
            testimonials: [
                {
                    quote:
                        "“SODECO didn’t just come to help us; they came to stay. Thanks to them, I received protection and care throughout my pregnancy, at a time when I didn’t even have enough to eat.”",
                    name: "Marina Pérez",
                    role: "Mother ·",
                },
                {
                    quote:
                        "“There were moments when I had nothing to eat and worried every day about how to feed my family and myself. When I could no longer bear it, I prayed to God for help ,and SODECO came. They brought protection, care, and the food that sustained us when we needed it most.”",
                    name: "Andrés Lugo",
                    role: "Volunteer · ",
                },
                {
                    quote:
                        "“I saw the greatness of God through SODECO. In my hardest moments, when I had nothing and felt hopeless, I prayed ,and God answered by sending SODECO. They cared for me, protected me, and gave me strength. Today I can say that God is wonderful, and SODECO is His instrument of love and hope in my life.”",
                    name: "Dr. Helena Rivas",
                    role: "VOLUNTEER",
                },
            ],

            bibleEyebrow: "Inspiration",
            bibleTitle: "Words that guide us every day.",
            bibleVerses: [
                {
                    text:
                        "“In every way I have shown you that by working hard in this way we must help the weak, and remember the words of the Lord Jesus, how he himself said, ‘It is more blessed to give than to receive.’”",
                    ref: "Acts 20:35",
                },
                {
                    text:
                        "“Religion that is pure and undefiled before God the Father is this: to visit orphans and widows in their affliction.”",
                    ref: "James 1:27",
                },
                {
                    text:
                        "“Open your mouth for the mute, for the rights of all who are destitute. Open your mouth, judge righteously, defend the rights of the poor and needy.”",
                    ref: "Proverbs 31:8-9",
                },
                {
                    text:
                        "“Truly, I say to you, as you did it to one of the least of these my brothers, you did it to me.”",
                    ref: "Matthew 25:40",
                },
            ],

            drEyebrow: "Caribbean · country focus",
            drTitle: "Our impact in the Dominican Republic.",
            drLead:
                "Since 2012, the Dominican Republic has become one of SODECO's operational hubs in the Caribbean. We have worked with communities in Barahona, Higüey, Santiago and along the Haitian border, articulating health, education, dignified housing and climate-resilience programs.",
            drStats: [
                { value: "13", label: "years in the country" },
                { value: "27", label: "communities served" },
                { value: "+85K", label: "Dominicans benefited" },
                { value: "9", label: "schools rebuilt" },
            ],
            drP1:
                "In 2017, after the devastating impact of Hurricane Maria, we deployed medical brigades and brought hope to the hardest-hit communities in the eastern part of the country, delivering more than 12,000 emergency kits. Our support reached entire families, destroyed homes, churches, schools, and people with disabilities who had been left in conditions of extreme vulnerability. More than a humanitarian response, it was a firm commitment to human dignity: being present when everything seemed lost and showing that solidarity can become the first step toward reconstruction and hope.",
            drP2:
                "We work hand in hand with local churches, neighborhood councils, and maternal and child health programs, strengthening community networks that generate real and sustainable support. We believe lasting change is born within the communities themselves; that is why we promote initiatives that not only address immediate needs but also foster education, well-being, inclusion, and opportunities for future generations.",

            staffEyebrow: "Who makes SODECO possible",
            staffTitle: "Our team.",
            staffSubtitle:
                "A clear, accountable structure. From strategic leadership to specialists on the ground.",
            staff: {
                ceo: { name: "Dr. Octavio Ariza", role: "President · CEO" },
                executiveDirector: { name: "Dr. Juan Martinez", role: "Executive Director · Co-founder" },
                managersLabel: "Managers",
                managers: [
                    { name: "Vicente Jimenez Geraldo", role: "Manager · Operations" },
                    { name: "Cesar Perez Valdez", role: "Manager · Programs" },
                    { name: "Richard de los Santos Estrella", role: "Manager · Comunity Operation" },
                ],
                supervisorsLabel: "Supervisors",
                supervisors: [
                    { name: "Dr. Jeffy Ariza Figueroa", role: "Supervisor · Health" },
                    { name: "Julio Cesar de La Cruz Garcia", role: "Supervisor · Education" },
                    { name: "Ivan monte de Oca", role: "Supervisor · Communication" },
                    { name: "Leona Montaño", role: "Supervisor · Logistics" },
                ],
                specialistsLabel: "Specialist agents",
                specialists: [
                    { name: "Angel Tineo", role: "Specialist · Information" },
                    { name: "Damian de Cruz Heredia", role: "Specialist · Volunteering" },
                    { name: "Eusebio Hernández", role: "Specialist · Volunteering" },
                    { name: "Valentina Cuevas", role: "Specialist · Psychology" },
                    { name: "Florentina Soto", role: "Specialist · Volunteering" },
                    { name: "Eduardo Castro", role: "Specialist · Volunteering" },
                ],
            },
        },
        missions: {
            eyebrow: "Timeline",
            title: "34 years on the ground.",
            subtitle:
                "A chronology of SODECO's humanitarian missions: places visited, people accompanied, lessons that transformed us.",
            visit: "Place visited",
        },
        contact: {
            eyebrow: "Let's talk",
            title: "Contact us.",
            subtitle:
                "Tell us how you'd like to collaborate — volunteering, institutional partnership, press or donations. We reply within 48 hours.",
            name: "Full name",
            email: "Email address",
            subject: "Subject",
            message: "Message",
            sent: "Message sent. Thank you for reaching out.",
            error: "We couldn't send your message. Please try again.",
            officeTitle: "Offices",
            offices: [
                { city: "Santo Domingo", line: "Calle M C 59" },
                { city: "Santo Domingo", line: "Calle M C 59" },
                { city: "Santo Domingo", line: "Calle M C 59" },
            ],
            hoursTitle: "Office hours",
            hoursLine: "Mon – Fri · 09:00 – 18:00",
            emailTitle: "Email",
            phoneTitle: "Phone",
        },
        footer: {
            tagline:
                "Solidarity and Community Development. Independent humanitarian foundation registered in 1994.",
            explore: "Explore",
            connect: "Connect",
            legal: "© " + new Date().getFullYear() + " SODECO. All rights reserved.",
        },
    },
};

export default content;
